module.exports = __webpack_public_path__ + "static/media/path.212b5e51.svg";